<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import html2pdf from 'html2pdf.js'
import Widget from './widget'


/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: '360MDR Real Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    Widget
  },
  props: {
    name: {
      type: String,
      default: 'main.json'
    }
  },
  data() {
    return {
      id: 1,
      dateUnit: 'unit',
      dashboard: {
        "widgets": [
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC_FW_PAN_COLBOG01",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,COLC_FW_PAN_COLBOG01&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "auxBool": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-COLBOG02",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,COLC_FW_PAN_COLBOG02&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW PA-RIO_CLARO-01",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,PA-RIO_CLARO-01&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "auxBool": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW PA-RIO_CLARO-02",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,PA-RIO_CLARO-02&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
         {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-CELTA-01",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,COLC-FW-PAN-CELTA-01&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "auxBool": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC-FW-PAN-CELTA-02",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,COLC-FW-PAN-CELTA-02&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC_FW_PAN_FUG_01",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,COLC_FW_PAN_FUG_01&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC_FW_PAN_FUG_02",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,COLC_FW_PAN_FUG_02&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW CORONA_USA_ALD-01",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,CORONA_USA_ALD-01&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000
          },
          {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW CORONA_USA_ALD-02",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,CORONA_USA_ALD-02&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000,
          },
           {
            "name": "PORCENTAJE DE DISPONIBILIDAD NGFW COLC_FW_PAN_AZ_VM500",
            "source": "/pan/ngfw/agg/uptime_new?gsearch=device,COLC_FW_PAN_AZ_VM500&[[DateUnit]]",
            "cols": "col-md-6",
            "height_class": "tall_widget",
            "cardStyle": "height:300px;",
            "component": "sbar",
            "labels": "server",
            "colors": ['#01AD00'],
            "range": true,
            "refresh": 60000,
          },         
        ]
      },
      // jsonDef: '@src/router/views/pages/dashboard/data/'+name,
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			error: null,
			title: 'Reporte de Disponibilidad de NGFW Palo Alto Networks - Corona',
			spacer: '',
			startEpoch: 0,
			endEpoch: 0,
			startDateTime: null,
			endDateTime: null,
      startDateTimeShow: null,
			endDateTimeShow: null,
			date: null,
			dateTimePicker: {
				enableTime: true,
				dateFormat: 'm/d/Y H:i',
			},
			finishedWidgetsCount: 0,
			widgetsStatus: [],
			base: 0,
			pdfConfig: {
				margin: 0.2,
				filename: 'Disponibilidad NGFW PAN Corona - Report.pdf',
				image: { type: 'jpeg', quality: 0.98 },
				html2canvas: { scale: 2, dpi: 96, letterRendering: true, width: 1280 },
				jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
				pagebreak: { mode: 'css', before: '#page2el' },
				_pageBreak: { mode: 'avoid-all', before: '.break-page', after:'.break-page'}
			},
    }
  },
    computed: {
      dateTimeFormatedRange: function () {
        let res = ''
        if (this.startDateTimeShow !== null) res += this.startDateTimeShow + ' - '
        if (this.endDateTimeShow !== null) res += this.endDateTimeShow 		
        return res
      }
  },
  mounted () {

    // console.log(this.jsonDef)
  },
  methods: {
    changeDateUnit(source) {
      let unit
      const diff = this.endEpoch - this.startEpoch
      switch (true) {
        case (diff > 3600 * 24 * 4 && diff <= 3600 * 24 * 60):
          unit = 'day'
          break
        case (diff > 3600 * 24 * 60):
          unit = 'month'
          break
        default:
          unit = 'hour'
      }
      let result = source.replace('[[DateUnit]]', 'unit='+unit)
      return result
    },
    changeDataLabels() {
      return false
      const [unit, limit] = this.dateUnit.split(',')
      if (parseInt(limit) > 10 && unit === 'day') {
        return false
      } else {
        return true
      }
    },
    showModal() {
			this.$refs['modal-datetime'].show()
		},
		handleOk (evt) {
      // console.log('startEpoch', this.startEpoch)
      // console.log('endEpoch', this.endEpoch)
			let that = this
			if (that.startDateTime === null) {
				that.error = "Please select a start date and time"
				evt.preventDefault()
			} else if (that.endDateTime === null) {
				that.error = "Please select an end date and time"
				evt.preventDefault()
			} else {
				that.startEpoch = parseInt(new Date(that.startDateTime).getTime()/1000)
				that.endEpoch = parseInt(new Date(that.endDateTime).getTime()/1000)
				that.base += 100
				that.error = null
				that.startDateTimeShow = that.startDateTime
				that.endDateTimeShow = that.endDateTime
				that.finishedWidgetsCount = 0
				that.widgetsStatus = []
			}
		},
		widgetFinished(id, ok, aux) {
			this.finishedWidgetsCount += 1
			this.widgetsStatus.push({id: id, ok: ok, aux: aux})
		},
		downloadPdf() {
			const element = document.getElementById('pdfcontent')
			html2pdf(element, this.pdfConfig)
    },
  },
}
</script>

<template>
  <Layout>
    <div class="container" style="max-width: 1420px !important;">
			<div class="row">
				<div class="col-md-12" style="text-align:center;">
					<template v-if="finishedWidgetsCount === dashboard.widgets.length">
						<b-button class="btn btn-primary btn-sm mr-1" variant="light" @click="downloadPdf()">
							Download PDF
						</b-button>
					</template>
					<template v-else>
						<span>
							Generating...
						</span>
					</template>
				</div>
			</div>
			<div id="pdfcontent" style="width:1280px;background-color: rgb(237, 239, 243); break-after: page; clear: both;padding-left:20px;padding-right:20px;">
				<section slot="pdf-content">
					<br><br><br><br><br><br><br>
					<div class="row">
						<div class="col-md-12 align-items-center" style="text-align:center">
							<h2 style="align:center;cursor:pointer;">
								{{ title }}
							</h2>
							<h4 style="align:center;cursor:pointer;" v-on:click="showModal">
								{{ dateTimeFormatedRange || 'últimas 24 horas'}}
							</h4>
						</div>
					</div>
					<br>
          <div class="row">
            <template v-for="(widget, index) in dashboard.widgets">
              <!-- <div :class="widget.cols">
                <span><h5>{{ widget.name }}</h5></span>
                <b-card no-body class="text-center" style="line-height:300px">
                  {{ widget.component }}
                </b-card>
              </div> -->
              <Widget :id="widget.name"
                      v-bind:key="index+startEpoch+endEpoch+base"
                      :title="widget.name"
                      :component="widget.component"
                      :source="changeDateUnit(widget.source)"
                      :series="widget.series"
                      :cols="widget.cols"
                      :trend="widget.trend"
                      :wclass="widget.class"
                      :type="widget.type"
                      :labels="widget.labels"
                      :cardStyle="widget.cardStyle"
                      :categories="widget.categories"
                      :colors="widget.colors"
                      :colorsByLabel="widget.colorsByLabel"
                      :range="widget.range"
                      :start="startEpoch"
                      :end="endEpoch"
                      :auxBool="changeDataLabels()"
                      @finished="widgetFinished"
              />
            </template>
          </div>
        </section>
      </div>
    </div>
    <b-modal
			ref="modal-datetime"
			id="id"
			size="xs"
			title="Select Time Range"
			:ok-only=true
			:centered=true
			:no-fade=true
			@ok="handleOk">
			<div class="row">
				<div class="col-md-6">
					<div class="form-group mb-3">
					<label>Start</label>
					<flat-pickr
						v-model="startDateTime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
					></flat-pickr>
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group mb-3">
					<label>End</label>
					<flat-pickr
						v-model="endDateTime"
						:config="dateTimePicker"
						class="form-control"
						placeholder="Date and Time"
					></flat-pickr>
					</div>
				</div>
			</div>
			<div v-if="error !== null" class="row">
				<div class="col-md-12 severity_high" style="text-align:center">
					{{ error }}
				</div>
			</div>
		</b-modal>
  </Layout>
</template>
